import { TandemEvent, ValidTandemEvent } from "@/lib/drivers/tandem/commands/Event";
import { CGMDataEvent, LID_CGM_DATA } from "@/lib/drivers/tandem/events/LID_CGM_DATA";
import { LID_CGM_DATA_G7 } from "@/lib/drivers/tandem/events/LID_CGM_DATA_G7";
import { LID_CGM_DATA_GX } from "@/lib/drivers/tandem/events/LID_CGM_DATA_GX";
import { LID_CGM_DATA_GXB } from "@/lib/drivers/tandem/events/LID_CGM_DATA_GXB";
import { TandemData } from "@/lib/drivers/tandem/TandemTypes";
import { TandemTransformer } from "@/lib/drivers/tandem/transformers/TandemTransformer";
import { GlycemiaDTO } from "@/models/GlycemiaModel";

export class TandemGlycemiaTransformer implements TandemTransformer<GlycemiaDTO[]> {
  _is_glycemia = (event: TandemEvent<unknown>): event is ValidTandemEvent<CGMDataEvent> =>
    event.id === LID_CGM_DATA.value && event.valid;

  _is_g7_glycemia = (event: TandemEvent<unknown>): event is ValidTandemEvent<CGMDataEvent> =>
    event.id === LID_CGM_DATA_G7.value && event.valid;

  _is_gx_glycemia = (event: TandemEvent<unknown>): event is ValidTandemEvent<CGMDataEvent> =>
    event.id === LID_CGM_DATA_GX.value && event.valid;

  _is_gxb_glycemia = (event: TandemEvent<unknown>): event is ValidTandemEvent<CGMDataEvent> =>
    event.id === LID_CGM_DATA_GXB.value && event.valid;

  get_glycemia = (pumpEvents: ValidTandemEvent<CGMDataEvent>[]): GlycemiaDTO[] => {
    const result: GlycemiaDTO[] = [];
    for (const event of pumpEvents) {
      if (event.payload.value) {
        result.push({
          date: event.timestamp.toISO() ?? "",
          value: event.payload.value,
          type: "interstitial",
          sequence_id: event.eventSequenceNum,
        });
      }
    }
    return result;
  };

  transform = (data: TandemData): GlycemiaDTO[] => {
    const events = data.events.events.filter(
      e => this._is_glycemia(e) || this._is_g7_glycemia(e) || this._is_gx_glycemia(e) || this._is_gxb_glycemia(e),
    );

    return this.get_glycemia(events);
  };
}
